import { render } from "./ModuleHrKnowledge.vue?vue&type=template&id=77edfe3b&scoped=true"
import script from "./ModuleHrKnowledge.vue?vue&type=script&lang=js"
export * from "./ModuleHrKnowledge.vue?vue&type=script&lang=js"

import "./ModuleHrKnowledge.vue?vue&type=style&index=0&id=77edfe3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77edfe3b"]])

export default __exports__